module.exports = {
      id: "palo-english-usage",
      viewBox: "0 0 230 78",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#palo-english",
      toString: function () {
        return this.url;
      }
    }